const capitalizeFirst = (value) => value.charAt(0).toUpperCase() + value.slice(1);

const normalizeWordCasing = (word) => {
  if (!word) return "";
  if (word === word.toUpperCase()) return word;
  if (word === word.toLowerCase()) return capitalizeFirst(word);
  return word;
};

export const formatRouteLabel = (value = "") =>
  value
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map(normalizeWordCasing)
    .join(" ");
